import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Compose Tailwind classes safely.
 *
 * `clsx` collapses conditionals (`{"foo": isActive}`, `foo && "bar"`),
 * then `tailwind-merge` deduplicates conflicting Tailwind utilities so a
 * child class list reliably wins over the parent's. Mirrors LibreChat's
 * `~/utils/cn`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
